import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox"]

  submit(event) {
    const form = event.target.closest('form')
    const formData = new FormData(form)
    const roleChip = event.target.closest('.role-chip')
    const originalState = !event.target.checked
    
    // Set the role_action based on the checkbox state
    formData.set('dashboard[role_action]', event.target.checked ? 'add' : 'remove')
    
    fetch(form.action, {
      method: form.method,
      headers: {
        'X-CSRF-Token': document.querySelector("[name='csrf-token']").content,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(Object.fromEntries(formData))
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        roleChip.classList.toggle('active', event.target.checked)
        this.showNotification('success', 'Role updated successfully')
      } else {
        event.target.checked = originalState
        roleChip.classList.toggle('active', originalState)
        this.showNotification('error', data.error || 'Failed to update role')
      }
    })
    .catch(error => {
      event.target.checked = originalState
      roleChip.classList.toggle('active', originalState)
      this.showNotification('error', 'An error occurred while updating role')
    })
  }

  showNotification(type, message) {
    const notification = document.createElement('div')
    notification.className = `notification notification-${type}`
    notification.innerHTML = `
      <div class="notification-content">
        <i class="fas ${type === 'success' ? 'fa-check-circle' : 'fa-exclamation-circle'}"></i>
        <span>${message}</span>
      </div>
    `
    document.body.appendChild(notification)
    requestAnimationFrame(() => notification.classList.add('show'))
    
    setTimeout(() => {
      notification.classList.remove('show')
      notification.addEventListener('transitionend', () => notification.remove())
    }, 3000)
  }
}
